// extracted by mini-css-extract-plugin
export default {"content":"Loading_content__jw3iL"};